import type { ComponentType } from "react";
import {
  AssistantsIcon,
  ChatIcon,
  type IconProps,
  ImageIcon,
  LibraryIcon,
  SkillsIcon,
  VideoIcon,
} from "./components/icons";

/** Primary workspace destinations shown as sidebar rows + palette commands. */
export type NavTo = "/chat" | "/images" | "/videos" | "/ugc" | "/library" | "/assistants" | "/skills";

export interface NavItem {
  to: NavTo;
  /** i18n key for the row label. */
  labelKey: string;
  Icon: ComponentType<IconProps>;
}

export const NAV_ITEMS: NavItem[] = [
  { to: "/chat", labelKey: "sidebar.chat", Icon: ChatIcon },
  { to: "/images", labelKey: "sidebar.images", Icon: ImageIcon },
  { to: "/videos", labelKey: "sidebar.videos", Icon: VideoIcon },
  { to: "/ugc", labelKey: "sidebar.ugc", Icon: VideoIcon },
  { to: "/library", labelKey: "sidebar.library", Icon: LibraryIcon },
  { to: "/assistants", labelKey: "sidebar.assistants", Icon: AssistantsIcon },
  { to: "/skills", labelKey: "sidebar.skills", Icon: SkillsIcon },
];
